export default __webpack_public_path__ + "e2fe0b87a94b280d0fd9ab0683061f82.png";